import React, { Component } from 'react';
import { Form } from 'informed';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import 'react-datepicker/dist/react-datepicker.css';

import { ContentWrapper, HeadingWrapper } from '../Shared/Structural';
import { TextInput } from '../Shared/TextInput';
import { StateSelect } from '../Shared/StateSelect';
import { Dialog } from '../Shared/Dialog';

import { AdvancedSearchFormStyles } from './styled-components';

export class AdvancedSearchForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: '1990-01-01',
      endDate: moment().format('YYYY-MM-DD')
    };
  }

  componentDidMount() {
    const input = document.querySelector('.search-form__input');
    const label = document.querySelector('.search-form__label');
    input.addEventListener('focus', () => {
      label.classList.add('active');
    });

    input.addEventListener('blur', () => {
      label.classList.remove('active');
    });
  }

  handleChangeStartDate = date => {
    this.setState({
      startDate: moment(date).format('YYYY-MM-DD')
    });
  };

  handleChangeEndDate = date => {
    this.setState({
      endDate: moment(date).format('YYYY-MM-DD')
    });
  };

  onSubmit = formState => {
    let state = formState;
    state.minDate = this.state.startDate;
    state.maxDate = this.state.endDate;
    this.props.onSubmit(state);
    this.props.close();
  };

  render() {
    const { startDate, endDate } = this.state;
    const { open, close } = this.props;

    return (
      <Dialog open={open} close={close}>
        <ContentWrapper>
          <HeadingWrapper>
            <h1 id="dialog-title">Advanced Search</h1>
          </HeadingWrapper>
          <AdvancedSearchFormStyles>
            <Form className="search-form--advanced" onSubmit={this.onSubmit}>
              <fieldset className="search-form__fieldset">
                <legend className="search-form__legend">
                  Donor Information
                </legend>
                <ul className="search-form__list">
                  <TextInput name="name" title="Name" width="full" />
                  <TextInput
                    name="occupation"
                    title="Occupation"
                    width="full"
                  />
                  <TextInput
                    name="minDonation"
                    title="Donation Min"
                    width="half"
                  />
                  <TextInput
                    name="maxDonation"
                    title="Donation Max"
                    width="half"
                  />
                </ul>
              </fieldset>

              <fieldset className="search-form__fieldset">
                <legend className="search-form__legend">Donor Address</legend>
                <ul className="search-form__list">
                  <TextInput
                    name="donorStreet"
                    title="Street Address"
                    width="full"
                  />
                  <TextInput name="donorCity" title="City" width="half" />
                  <StateSelect name="donorState" title="State" width="half" />
                  <TextInput name="donorZip" title="Zip Code" width="half" />
                </ul>
              </fieldset>

              <fieldset className="search-form__fieldset">
                <legend className="search-form__legend">
                  Employer Information
                </legend>
                <ul className="search-form__list">
                  <TextInput
                    name="employerName"
                    title="Employer Name"
                    width="full"
                  />
                  <TextInput name="employerCity" title="City" width="half" />
                  <StateSelect
                    name="employerState"
                    title="State"
                    width="half"
                  />
                  <TextInput name="employerZip" title="Zip Code" width="half" />
                </ul>
              </fieldset>

              <fieldset className="search-form__fieldset">
                <legend className="search-form__legend">Recipient</legend>
                <ul className="search-form__list">
                  <TextInput name="recipientName" title="Name" width="full" />
                </ul>
              </fieldset>

              <fieldset className="search-form__fieldset">
                <legend className="search-form__legend">Date Range</legend>
                <ul className="search-form__list">
                  <li className="search-form__item half">
                    <label className="search-form__label" htmlFor="startDate">
                      Start Date
                    </label>
                    <DatePicker
                      selected={moment(startDate)}
                      onChange={this.handleChangeStartDate}
                      className="date-input"
                      id="minDate"
                    />
                  </li>
                  <li className="search-form__item half">
                    <label className="search-form__label" htmlFor="endDate">
                      End Date
                    </label>
                    <DatePicker
                      selected={moment(endDate)}
                      onChange={this.handleChangeEndDate}
                      className="date-input"
                      id="maxDate"
                    />
                  </li>
                </ul>
              </fieldset>

              <button type="submit" className="search-form__button">
                Search
              </button>
            </Form>
          </AdvancedSearchFormStyles>
        </ContentWrapper>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdvancedSearchForm/AdvancedSearchForm.js